var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-relation-card-collapsed',_vm._g({key:_vm.uuid,attrs:{"title":_vm.name,"draggable":_vm.draggable,"icon":"web","dark":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }